module.exports = __webpack_public_path__ + "static/img/16areaB_4.bca2a4b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/16areaB_4.png
// module id = 1133
// module chunks = 1